import { render } from "./EditShippingMethod.vue?vue&type=template&id=6eb2f82b&scoped=true&ts=true"
import script from "./EditShippingMethod.vue?vue&type=script&lang=ts"
export * from "./EditShippingMethod.vue?vue&type=script&lang=ts"

import "./EditShippingMethod.vue?vue&type=style&index=0&id=6eb2f82b&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb2f82b"]])

export default __exports__